// extracted by mini-css-extract-plugin
export default {"banner":"NewsPage_banner__o7+Mh","bannerContent":"NewsPage_bannerContent__xTlfw"};